import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'om-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  @Input() options: string[];
  @Input() optionSubmitted: string;
  @Output() optionSelected = new EventEmitter<string>();
  @Input() disabled: boolean;

  selectedOption: string;

  constructor() {}

  ngOnInit() {
    this.selectedOption = this.optionSubmitted;
  }

  selectValue(option: string, event) {
    if (this.disabled) {
      return;
    }

    this.selectedOption = option;
    this.optionSelected.emit(this.selectedOption);
  }

  isSelected(option: string): boolean {
    return this.selectedOption === option;
  }
}
